import ContentLoader from 'react-content-loader'

export const SkeletonSearchShipping = () => {
  return (
    <ContentLoader
      backgroundColor="#f3f3f3"
      data-testid="skeleton-search-shipping"
      foregroundColor="#ecebeb"
      height="25.5rem"
      speed={2}
      title="Carregando..."
      uniqueKey="loader-search-shipping"
      width="100%"
    >
      <rect
        height="1.125rem"
        rx="0.313rem"
        ry="0.313rem"
        width="10rem"
        x="0"
        y="1.563rem"
      />
      <rect
        height="1rem"
        rx="0.313rem"
        ry="0.313rem"
        width="14.375rem"
        x="0"
        y="4.063rem"
      />
      <rect
        height="1rem"
        rx="0.313rem"
        ry="0.313rem"
        width="8rem"
        x="0"
        y="6.5rem"
      />
      <rect
        height="1rem"
        rx="0.313rem"
        ry="0.313rem"
        width="4.375rem"
        y="6.5rem"
        style={{ transform: 'translate(76.4%, 0%)' }}
      />
      <rect
        height="0.875rem"
        rx="0.313rem"
        ry="0.313rem"
        width="11rem"
        x="0"
        y="8.1rem"
      />
      <rect
        height="0.875rem"
        rx="0.313rem"
        ry="0.313rem"
        width="6rem"
        x="0"
        y="9.5rem"
      />
      <rect
        height="2.625rem"
        rx="0.313rem"
        ry="0.313rem"
        width="100%"
        x="0"
        y="11.5rem"
      />
      <rect
        height="10rem"
        rx="0.313rem"
        ry="0.313rem"
        width="100%"
        x="0"
        y="15.3rem"
      />
    </ContentLoader>
  )
}
